// ProductSearchDropdown — filter-as-you-type product selector.
//
// products: array of { artikelnummer, name, … } from the product catalog.
// onSelect: called with the full product object when user picks an item.
// Uses onMouseDown on list items (not onClick) so the selection fires before
// any blur event that would close the list first.

import { useState, useEffect, useRef } from "react";
import "./Matching.css";

export default function ProductSearchDropdown({
  products,
  onSelect,
  placeholder = "Search by number or name…",
  disabled = false,
}) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const filtered = !query
    ? products
    : products.filter(
        (p) =>
          (p.artikelnummer || "").toLowerCase().includes(query.toLowerCase()) ||
          (p.name || "").toLowerCase().includes(query.toLowerCase())
      );

  // Close when user clicks outside the component
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const handleSelect = (product) => {
    setQuery("");
    setOpen(false);
    onSelect(product);
  };

  return (
    <div className="mt-psd" ref={wrapRef}>
      <input
        className="ds-input ds-input--sm mt-psd-input"
        type="text"
        value={query}
        placeholder={disabled ? "Loading catalog…" : placeholder}
        disabled={disabled}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Escape") setOpen(false);
        }}
      />
      {open && !disabled && (
        <ul className="mt-psd-list">
          {filtered.length === 0 ? (
            <li className="mt-psd-empty">No results</li>
          ) : (
            filtered.map((p) => (
              <li
                key={p.artikelnummer || p.name}
                className="mt-psd-item"
                onMouseDown={() => handleSelect(p)}
              >
                {p.artikelnummer} — {p.name}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
}
